import { ColumnLayout, Flashbar, Multiselect } from '@amzn/awsui-components-react-v3';
import { Button } from 'AWS-UI-Components-React';
import React from 'react';
import { downloadFile } from '../../../utilities';
import { DATE_YYYYMM } from '../../../utils/date-utils';
import logger from '../../../utils/logging';
import { accumulateProductLineById } from '../../../utils/product_line';
import { Asterisk } from '../../buttons/asterisk';
import { MarketplaceSelection } from '../../buttons/marketplace_selection';
import { TimeFrameButton } from '../../buttons/time_frame_button';
import { ChannelItems } from '../../const/dropdown_elements';
import { getJSClient } from '../../js_client';
import { findOptions } from '../../reports/utils/buttons';

export class DownloadAdjustmentTemplate extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      marketplaceOptions: [],
      selectedTimeFrameIds: [],
      selectedMarketplaceIds:[],
      selectedAccountsIds: [],
      templateLoadError: false,
    };

    this.productLinesById = [];

    let accountMap = {};
    for (let cognosAccount of props.cognosConfig) {
      accountMap[cognosAccount.id] = cognosAccount;
      cognosAccount.excluded = cognosAccount.excluded || false;
    }
    this.accountOptions = Object.keys(accountMap).filter((key) => !accountMap[key].excluded && !accountMap[key].ignored)
                                .map((id) => {return {label: `${id} - ${accountMap[id].detail}`, id: id, value:id};});

    this.channelTypes = ChannelItems.map((mp) => mp.value)
                                    .filter((value => value !== "ALL"))

  }

  componentDidMount = () => {
    this.client = getJSClient();
    this.getMarketplaceOptions();
    this.getProductLines();
  }

  getMarketplaceOptions = () => {
    const marketplaceConfig = this.props.marketplaceConfig;
    const marketplaceOptions = Object.keys(marketplaceConfig).filter((id) => marketplaceConfig[id].detail !== "ALL").map((id) => {
      let marketplaceItem = marketplaceConfig[id];
      return {
        label: `${marketplaceItem.id.trim()} - ${marketplaceItem.detail.trim()}`,
        value: marketplaceItem.id.trim(),
        id: marketplaceItem.id.trim(),
      };
    });
    this.setState({marketplaceOptions});
  }

  getProductLines = () => {
    this.client.getPlHierarchy(
      (result) => {
        this.onPlHierarchyPullSuccess(result);
      },
      (error) => {
        logger.error(error);
        this.setState({templateLoadError : true})
      },
      {}
    );
  };

  onPlHierarchyPullSuccess = (data) => {
    const productLinesByIdMap = {};
    accumulateProductLineById(data.root, null, productLinesByIdMap);
    this.productLinesById = Object.keys(productLinesByIdMap).filter((key) => productLinesByIdMap[key].isLeaf && key !== "-1");
  };

  onTimeFrameChange = (chosen) => {
    const ids = chosen.detail.selectedOptions.map(o => o.value);
    this.setState({selectedTimeFrameIds: ids})
  }

  onMarketplaceChange = (chosen) => {
    const { detail } = chosen;
    const { selectedOptions } = detail;
    const selectedMarketplaceIds = selectedOptions
                                   ? selectedOptions.map((marketplace) => parseInt(marketplace.value, 10)).join() : '';
    this.setState({selectedMarketplaceIds: selectedMarketplaceIds})
  };

  onAccountChange = (chosen) => {
    const ids = chosen.detail.selectedOptions.map(o => o.value);
    this.setState({selectedAccountsIds: ids})
  }

  downloadTemplate = () => {
    const headings = ['month', 'account', 'marketplace', 'channel', 'pl', 'amount','comments','update_record'];
    let array = [headings.join(',')];
    this.state.selectedTimeFrameIds.forEach((month) => {
      month = month.replace('/', '');
      this.state.selectedAccountsIds.forEach((account) => {
        this.state.selectedMarketplaceIds.split(",").forEach((marketplace) => {
          this.channelTypes.forEach((channel) => {
            this.productLinesById.forEach((pl) => {
              const rowArray = [month, account, marketplace, channel, pl, '0', '', 'no'];
              array.push(rowArray.join(','));
            })
          })
        })
      })
    });
    downloadFile(array.join('\n'), "benchmark_adjustment_template.csv");
  };

  isDownloadDisabled = () => {
    return !(this.state.selectedTimeFrameIds.length && this.state.selectedMarketplaceIds.length && this.state.selectedAccountsIds.length);
  };

  render() {
    const {
      marketplaceOptions,
      selectedMarketplaceIds,
      selectedTimeFrameIds,
      selectedAccountsIds,
      templateLoadError
    } = this.state;

    return (
      <div>
        {!templateLoadError && (
          <ColumnLayout columns={ 3 }>
            <TimeFrameButton
              text="Time Frame"
              startMonth={ DATE_YYYYMM.START_MONTH }
              endMonth={ DATE_YYYYMM.PREV_MONTH }
              yearQuarter={ false }
              onChange={ this.onTimeFrameChange }
              selected={ selectedTimeFrameIds }
              multiSelect={ true }
              required={ true }
            />
            <MarketplaceSelection
              text="Marketplace"
              options={ marketplaceOptions }
              onChange={ this.onMarketplaceChange }
              selected={ selectedMarketplaceIds }
              multiselect={ true }
              required={ true }
            />
            <div>
              <b> { "Account" } </b>
              <Asterisk required={ true } />
              <Multiselect
                filteringType={ 'auto' }
                placeholder={ "Account" }
                options={ this.accountOptions }
                onChange={ this.onAccountChange }
                selectedOptions={ findOptions(this.accountOptions, selectedAccountsIds) }
              />
            </div>
            <div>
              <Button
                text="Download Template"
                icon="download"
                onClick={ this.downloadTemplate }
                disabled={ this.isDownloadDisabled() }
              />
            </div>
          </ColumnLayout>
        )}
        {templateLoadError && (
          <Flashbar items={[
            {
              header: "Failed to load data for template download",
              type: "error",
            }
          ]} />
        )}
      </div>
    );
  }
}


// WEBPACK FOOTER //
// ./src/components/config_central/benchmark_adjustment/download_template.jsx